import { handleActions } from 'redux-actions';
import { initialContentState, contentReducerDefinition } from './content';
import { initialPublishedEventState, publishedEventReducerDefinition } from './published-event';
import { initialPublisherState, publisherReducerDefinition } from './publisher';

export const initialState = {
  ...initialContentState,
  ...initialPublishedEventState,
  ...initialPublisherState
};

const reducer = handleActions({
  ...contentReducerDefinition,
  ...publishedEventReducerDefinition,
  ...publisherReducerDefinition
}, initialState);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/reducers.js